define('components/course/models/level',[
    'components/course/collections/modules',
    'components/course/models/base'
], function (Modules, Base) {
    "use strict";

    return Base.extend({
        "authoringJSONKey": function () {
            return _.extend(Base.prototype.authoringJSONKey.call(this), {
                "description": null,
                "icon": null,
                "materialsData": null,
                "isUnlocked": null
            });
        },

        "childrenAttribute": "modules",

        "urls": {
            "editorial": "./level.cfc",
            "runtime": window.initData.appUrl + "/api:selfPacedCourse/level"
        },

        "complexRelations": function () {
            var complexRelations = Base.prototype.complexRelations.call(this);

            complexRelations = _.union(complexRelations, [
                {
                    "attr": "modules",
                    "Class": Modules
                }
            ]);

            return complexRelations;
        },

        "defaults": function () {
            return _.extend(Base.prototype.defaults.call(this), {
                "description": null,
                "icon": null,
                "title": null,
                "modules": null,
                "isUnlocked": false
            });
        }
    });
});

